<template>
  <div id="">
    <el-page-header style="margin-bottom:15px;" @back="goBack" :content="schoolName">
    </el-page-header>
    <el-table element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" border stripe
      :row-style="{ height: '48px' }" :header-cell-style="{ background: '#f5f5f5', height: '48px' }" :data="tableData"
      style="width: 100%" row-key="id" default-expand-all :tree-props="{ children: 'childs' }">
      <el-table-column label="评价维度" width="220" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.nodeName }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="nodeWeight"
        label="权重"
        align="center"
        width="50"
      ></el-table-column> -->
      <el-table-column label="观测点" align="center" width="350">
        <template slot-scope="scope">
          <div slot="reference" v-for="(list, index) in scope.row.pointList" style="text-align: left" :key="index">
            {{ list.pointContent }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="课程或活动" align="center">
        <template slot-scope="scope">
          <div slot="reference" v-for="(list, index) in scope.row.courseListVos" :key="index" style="text-align: left">
            {{ list.com_name }}：
            <div v-for="(item, index) in list.pointListVos" :key="index">
              {{ index + 1 }}、{{ item.pointContent }}
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { nodeCourseList } from '@/api/home'
export default {
  data() {
    return {
      schoolId: 0,
      schoolName: '',
      loading: false,
      tableData: []
    }
  },
  created() {
    this.schoolId = this.$route.query.schoolId
    this.schoolName = this.$route.query.schoolName
    this.nodeCourseList()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    async nodeCourseList() {
      let params = {
        schoolId: this.schoolId,
        appSecret: 'U2FsdGVkX19OZOcU4KhX71qxjqtm9nOk03RcHEUlLpY=',
        appCode: 'ZHSZPJ',
        tempTypeId: 1
      }
      const { data: res } = await nodeCourseList(params)
      this.tableData = res.data
    }
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/school/components/observation.vue